import {
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableHead,
  Typography,
  TableRow,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import _ from "underscore";

import {
  Button,
  Modal,
  BorderTableCell,
  StyledTableContainer,
  TextButton,
} from "../../../../../../components/base";
import { Checkbox } from "../../../../../../components/base/Checkbox";
import { ModalTitle } from "../../../../../../components/base/Modal";
import { ModalBox } from "../../../../../../components/boxes";
import { COLORS } from "../../../../../../theme/colors";

const useStyles = makeStyles((theme) => ({
  subTitleContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    "& p:first-child": {
      fontStyle: "italic",
      color: COLORS.darks[0][50],
    },
  },
}));

export const ClusterBuildingModal = ({
  cluster = {},
  buildings = [],
  onSave,
  open,
  onClose,
  removeCluster,
}) => {
  const classes = useStyles();

  const [selectedBuildingIds, setSelectedBuildingIds] = useState([]);

  useEffect(() => {
    if (cluster.buildings?.length) {
      setSelectedBuildingIds(cluster.buildings.map((b) => b.id));
    }
  }, [cluster.buildings]);

  const onSelectBuildingChange = (buildingId, elEvent) => {
    const selected = elEvent.target.checked;
    const existBuildingId = selectedBuildingIds.find((e) => e === buildingId);
    if (selected && existBuildingId === undefined) {
      setSelectedBuildingIds([buildingId, ...selectedBuildingIds]);
    }
    if (!selected && existBuildingId) {
      setSelectedBuildingIds(_.without(selectedBuildingIds, existBuildingId));
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox maxWidth="md" width={600}>
        <ModalTitle
          title={cluster.name + `${cluster.name ? " - " : ""}Cluster’s Buildings`}
          onClose={onClose}
        />
        <Grid
          className={classes.subTitleContainer}
          container
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography>Which buildings belong to this cluster?</Typography>
          <Typography color="primary">{selectedBuildingIds.length} selected</Typography>
        </Grid>
        <StyledTableContainer style={{ marginBottom: 20 }}>
          <Table>
            <TableHead>
              <TableRow>
                <BorderTableCell>Building name/Address</BorderTableCell>
                <BorderTableCell align="center">Include</BorderTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {buildings.map((building, i) => (
                <TableRow key={i}>
                  <BorderTableCell>{building.name}</BorderTableCell>
                  <BorderTableCell align="center">
                    {!building.in_cluster || building.in_cluster.id === cluster.id ? (
                      <Checkbox
                        style={{ margin: "auto" }}
                        checked={selectedBuildingIds.includes(building.id)}
                        onChange={(e) => onSelectBuildingChange(building.id, e)}
                      />
                    ) : (
                      <Grid container direction="column" alignItems="center">
                        <Typography>In &quot;{building.in_cluster.name}&quot; cluster.</Typography>
                        <TextButton
                          text="Remove"
                          textStyle={{ color: COLORS.red }}
                          onClick={() => removeCluster(building)}
                        />
                      </Grid>
                    )}
                  </BorderTableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </StyledTableContainer>
        <Button
          text="Save"
          onClick={() => {
            onSave(selectedBuildingIds);
            onClose();
          }}
        />
      </ModalBox>
    </Modal>
  );
};
